import { render, staticRenderFns } from "./2_m_officer.vue?vue&type=template&id=28f7c44b&scoped=true&"
import script from "./2_m_officer.vue?vue&type=script&lang=js&"
export * from "./2_m_officer.vue?vue&type=script&lang=js&"
import style0 from "./2_m_officer.vue?vue&type=style&index=0&id=28f7c44b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f7c44b",
  null
  
)

export default component.exports